module.exports = __webpack_public_path__ + "static/media/error-bench.5dec1f5c.svg";